import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../../../../../Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../../helper/config/api.config';
@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayService {
  constructor(
    private dataProvider: DataService
  ) {

  }

  checkPayment(): Observable<any> {
    return this.dataProvider.Get(AppConfig.CheckPayment);
  }
  invoicePayment(): Observable<any> {
    return this.dataProvider.Get(AppConfig.InvoicePayment);
  }
}
